import type { Dispatch } from 'react';

export const dispatchify = <T extends (...args: any[]) => any>(
  fn: T,
  dispatch: Dispatch<any>,
) => (...args: Parameters<T>) => dispatch(fn(...args));
